import { useRecoilCallback } from 'recoil'
import {
  editorClipboardAtom,
  itemAtomFamily,
  itemIdAtom,
  selectedItemsAtom,
} from 'atoms'
import { unsavedChangesAtom } from '@/atoms/_editorAtoms'
import { isEditorTextBoxItem } from '@/utils/editor-text-box/editorTextBoxAdapter'
import { useEditorPasteTextBoxFromClipboard } from '@/hooks/editor/useEditorPasteTextBoxFromClipboard'
import { v4 as uuidv4 } from 'uuid'

export const usePasteMultipleItemsFromClipboard = () => {
  const pasteTextBox = useEditorPasteTextBoxFromClipboard()

  return useRecoilCallback(
    ({ snapshot, set }) =>
      async () => {
        const [clipboard, itemIds] = await Promise.all([
          snapshot.getPromise(editorClipboardAtom),
          snapshot.getPromise(itemIdAtom),
        ])

        const newSelectedItemsIds = []
        const clonedItems = []
        const newItemIds = [...itemIds]

        for (const item of clipboard) {
          if (isEditorTextBoxItem(item)) {
            const newBoxId = await pasteTextBox(item)
            if (newBoxId) newSelectedItemsIds.push(newBoxId)
            continue
          }
          const copiedItem = { ...item }
          copiedItem.id = uuidv4()
          copiedItem.x = parseInt(copiedItem.x) + 15
          copiedItem.y = parseInt(copiedItem.y) + 15

          set(itemAtomFamily(copiedItem.id), copiedItem)
          newItemIds.push(copiedItem.id)
          newSelectedItemsIds.push(copiedItem.id)
          clonedItems.push(copiedItem)
        }

        set(itemIdAtom, newItemIds)
        set(selectedItemsAtom, newSelectedItemsIds)
        if (clonedItems.length > 0) set(editorClipboardAtom, clonedItems)
        if (newSelectedItemsIds.length > 0) set(unsavedChangesAtom, true)
      },
    [pasteTextBox],
  )
}

export default usePasteMultipleItemsFromClipboard
